import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        background: 'rgba(255,255,255,0.03)',
        backdropFilter: 'blur(12px)',
        border: '1px solid rgba(201,168,76,0.3)',
        color: '#C9A84C',
        padding: '10px 20px',
        borderRadius: '4px',
        fontSize: '13px',
        letterSpacing: '0.06em',
        cursor: 'pointer',
        marginBottom: '32px',
        transition: 'all 0.2s',
      }}
      onMouseEnter={e => { e.currentTarget.style.background = 'rgba(201,168,76,0.08)'; e.currentTarget.style.borderColor = 'rgba(201,168,76,0.6)'; }}
      onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.03)'; e.currentTarget.style.borderColor = 'rgba(201,168,76,0.3)'; }}
    >
      ← Back to Home
    </button>
  );
};

export default BackButton;